import { BtcLogo } from '@/shared/assets/token-logos';
import { TokenWithChain, type TokenWithChainSize } from '@/shared/components/logo/TokenWithChain';

export const BoostIcon = (props?: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3769_5826)">
      <rect width="24" height="24" rx="4.5" fill="#281520" />
      <rect
        width="24"
        height="24"
        rx="4.5"
        fill="url(#paint0_radial_3769_5826)"
        fillOpacity="0.15"
      />
      <rect
        x="0.75"
        y="0.75"
        width="22.5"
        height="22.5"
        rx="3.75"
        stroke="#FF5DE1"
        strokeOpacity="0.13"
        strokeWidth="1.5"
      />
      <g clipPath="url(#clip1_3769_5826)">
        <path
          d="M10.9999 13H7.79993L12.9999 6.20001V11H16.1999L10.9999 17.8V13Z"
          stroke="#FF33AF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_3769_5826"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3.75 -5.25) rotate(58.4957) scale(27.2695)"
      >
        <stop stopColor="#FF33AF" />
        <stop offset="1" stopColor="#FF33AF" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_3769_5826">
        <path
          d="M0 4.5C0 2.01472 2.01472 0 4.5 0H19.5C21.9853 0 24 2.01472 24 4.5V19.5C24 21.9853 21.9853 24 19.5 24H4.5C2.01472 24 0 21.9853 0 19.5V4.5Z"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_3769_5826">
        <rect width="16.9412" height="16.9412" fill="white" transform="translate(3.5293 3.52936)" />
      </clipPath>
    </defs>
  </svg>
);

function BoostPoolLogo({ size = 'large' }: { size?: TokenWithChainSize }): React.JSX.Element {
  return (
    <div className="relative h-[37px] w-[35px]">
      <div className="absolute bottom-px">
        <TokenWithChain chainLogo={BoostIcon} tokenLogo={BtcLogo} size={size} />
      </div>
    </div>
  );
}

export default BoostPoolLogo;
